import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Error } from '../models/error.model';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class ErrorService {

    private endpoint = 'logs';
   //private serviceUrl = 'http://192.168.1.229:8000/sonavie/logs'; 

    constructor(private http: HttpClient, private api: Api) { }
    getError(): Observable<Error[]> {
        return this.api.get(this.endpoint);
    }

}



// WEBPACK FOOTER //
// ./src/app/admin-app/services/error.service.ts